import React from "react";
import { FaTelegramPlane } from "react-icons/fa";

export default function Button({ value, className, showIcon = false }) {
  return (
    <button className={className}>
      {showIcon && (
        <div
          style={{
            backgroundColor: "white",
            color: "hsl(205, 72%, 37%)",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FaTelegramPlane />
        </div>
      )}
      {value}
    </button>
  );
}
